var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-3d537efe"), n = n(), _popScopeId(), n); };
var _hoisted_1 = {
    key: 0,
    class: "hidden absolute top-0 left-0 w-full h-full bg-black overlay-gradient md:block"
};
var _hoisted_2 = { class: "container" };
var _hoisted_3 = {
    class: "mb-12",
    href: "/school"
};
var _hoisted_4 = { class: "text-white" };
var _hoisted_5 = {
    key: 0,
    class: "mt-12 flex relative justify-center items-center w-52 h-16 rounded-lg",
    href: "/public"
};
var _hoisted_6 = ["src"];
var _hoisted_7 = ["textContent"];
var _hoisted_8 = ["innerHTML"];
var _hoisted_9 = { key: 2 };
var _hoisted_10 = { class: "flex items-center mt-5 text-white" };
var _hoisted_11 = { key: 0 };
var _hoisted_12 = { class: "mt-2 text-3xl font-medium" };
var _hoisted_13 = {
    key: 0,
    class: "mr-2 text-white text-opacity-60 line-through"
};
var _hoisted_14 = { key: 0 };
var _hoisted_15 = {
    key: 1,
    class: "text-white"
};
var _hoisted_16 = { key: 0 };
var _hoisted_17 = {
    key: 2,
    class: "text-white"
};
var _hoisted_18 = { class: "w-fit" };
var _hoisted_19 = {
    key: 3,
    class: "mt-2.5 text-center"
};
var _hoisted_20 = {
    key: 0,
    class: "text-gray-400"
};
var _hoisted_21 = {
    key: 1,
    class: "text-red-400"
};
var _hoisted_22 = {
    key: 2,
    class: "text-gray-400"
};
import { CourseStore } from '@student/modules/store';
import { computed, ref } from 'vue';
import { useLandingBlock } from '@student/components/Landing/Course/Blocks/useLandingBlock';
import { isIOSApp, isIOSModeratorSchool, requestApplePayment } from '@common/utils/MobileApp';
import { fakePaymentApi } from '@student/modules/api/fakePayment/fakePayment.api';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CourseHeader',
    props: {
        landingBlock: {}
    },
    emits: ["buyCourse"],
    setup: function (__props, _a) {
        var _this = this;
        var __emit = _a.emit;
        var props = __props;
        var emit = __emit;
        var t = useI18n().t;
        var _b = useLandingBlock(function () { return props.landingBlock; }), courseLanding = _b.courseLanding, plansPayment = _b.plansPayment, plans = _b.plans, minimalPlansPrice = _b.minimalPlansPrice, minimalPlansPriceOld = _b.minimalPlansPriceOld, hasDiscount = _b.hasDiscount, landingCurrency = _b.landingCurrency, orderAction = _b.orderAction, parseTextWithUrl = _b.parseTextWithUrl;
        var fakePurchaseLoading = ref(false);
        var course = computed(function () { return CourseStore.course; });
        var landingPurchaseLoading = computed(function () { return CourseStore.landingPurchaseLoading; });
        var landing = computed(function () { return CourseStore.landing; });
        var backgroundImage = computed(function () {
            return props.landingBlock ? props.landingBlock.background : '/img/common/components/landings/course/header/demo-bg.jpg';
        });
        var studentLimits = computed(function () {
            var e_1, _a;
            var _b, _c, _d;
            var hasLimitCourse = false;
            var leftLimitStudentsCourse = 0;
            var limitStudentsCourse = 0;
            if ((_b = CourseStore.plans) === null || _b === void 0 ? void 0 : _b.length) {
                //проверяю, что нет планов с неограниченным кол-вом мест
                var allHaveLimit = CourseStore.plans.every(function (plan) { var _a, _b; return ((_a = plan === null || plan === void 0 ? void 0 : plan.group) === null || _a === void 0 ? void 0 : _a.limitStudents) !== null && ((_b = plan === null || plan === void 0 ? void 0 : plan.group) === null || _b === void 0 ? void 0 : _b.limitStudents) !== undefined; });
                if (allHaveLimit) {
                    try {
                        for (var _f = __values(CourseStore.plans), _g = _f.next(); !_g.done; _g = _f.next()) {
                            var plan = _g.value;
                            var limitStudents = ((_c = plan === null || plan === void 0 ? void 0 : plan.group) === null || _c === void 0 ? void 0 : _c.limitStudents) || null;
                            var studentsCount = (_d = plan === null || plan === void 0 ? void 0 : plan.group) === null || _d === void 0 ? void 0 : _d.studentsCount;
                            var leftLimitStudents = limitStudents ? limitStudents - studentsCount : null;
                            var hasLimit = limitStudents !== null;
                            if (hasLimit) {
                                hasLimitCourse = true;
                                leftLimitStudentsCourse += leftLimitStudents;
                                limitStudentsCourse += limitStudents;
                            }
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_g && !_g.done && (_a = _f.return)) _a.call(_f);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                }
            }
            else {
                var group = CourseStore.course.group;
                var limitStudents = group.limitStudents || 0;
                var studentsCount = group.studentsCount;
                var leftLimitStudents = limitStudents ? limitStudents - studentsCount : 0;
                var hasLimit = group.limitStudents !== null;
                if (hasLimit) {
                    hasLimitCourse = true;
                    leftLimitStudentsCourse += leftLimitStudents;
                    limitStudentsCourse += limitStudents;
                }
            }
            return {
                hasLimitCourse: hasLimitCourse,
                leftLimitStudentsCourse: leftLimitStudentsCourse,
                lastChangeCourse: 6 > leftLimitStudentsCourse || limitStudentsCourse / 100 * 20 > leftLimitStudentsCourse,
            };
        });
        var fakePayment = function () { return __awaiter(_this, void 0, void 0, function () {
            var paymentId, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fakePurchaseLoading.value = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, requestApplePayment()];
                    case 2:
                        paymentId = _a.sent();
                        return [4 /*yield*/, fakePaymentApi.addStudentToCourseAfterPayInIOS(course.value.id, {
                                paymentId: paymentId,
                            })];
                    case 3:
                        _a.sent();
                        document.location.reload();
                        return [3 /*break*/, 5];
                    case 4:
                        err_1 = _a.sent();
                        console.error(err_1);
                        return [3 /*break*/, 5];
                    case 5:
                        fakePurchaseLoading.value = false;
                        return [2 /*return*/];
                }
            });
        }); };
        //Плюрализм
        return function (_ctx, _cache) {
            var _a, _b;
            var _component_e_icon = _resolveComponent("e-icon");
            var _component_e_button = _resolveComponent("e-button");
            return (_openBlock(), _createElementBlock("section", {
                style: _normalizeStyle({
                    backgroundImage: 'url(' + (backgroundImage.value) + ')'
                }),
                class: "relative pt-10 pb-28 section"
            }, [
                (_ctx.landingBlock && _ctx.landingBlock.sideDimming)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1))
                    : _createCommentVNode("", true),
                _createElementVNode("div", {
                    style: _normalizeStyle({
                        opacity: _ctx.landingBlock ? _ctx.landingBlock.sideDimmingValue / 100 : .6
                    }),
                    class: "absolute top-0 left-0 w-full h-full bg-black overlay"
                }, null, 4),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("a", _hoisted_3, [
                        _createVNode(_component_e_button, {
                            type: "secondary",
                            glass: ""
                        }, {
                            default: _withCtx(function () { return [
                                _createVNode(_component_e_icon, {
                                    class: "mr-2 w-4 h-4 text-gray-400",
                                    icon: "arrow-left-long"
                                }),
                                _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('course.allCourses')), 1)
                            ]; }),
                            _: 1
                        })
                    ]),
                    (_ctx.landingBlock && _ctx.landingBlock.image)
                        ? (_openBlock(), _createElementBlock("a", _hoisted_5, [
                            _createElementVNode("img", {
                                src: _ctx.landingBlock.image,
                                alt: "",
                                class: "object-contain relative w-full h-full object-left"
                            }, null, 8, _hoisted_6)
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("h1", {
                        class: _normalizeClass([[
                                _ctx.landingBlock && _ctx.landingBlock.image ? 'mt-16' : 'mt-44',
                            ], "max-w-lg font-medium text-white md:text-2xl md:text-5xl"]),
                        textContent: _toDisplayString(_ctx.landingBlock ? _ctx.landingBlock.title : course.value.name)
                    }, null, 10, _hoisted_7),
                    (_ctx.landingBlock)
                        ? (_openBlock(), _createElementBlock("p", {
                            key: 1,
                            class: "mt-3 max-w-lg text-white md:text-lg",
                            innerHTML: _unref(parseTextWithUrl)(_ctx.landingBlock.subtitle)
                        }, null, 8, _hoisted_8))
                        : _createCommentVNode("", true),
                    (_ctx.landingBlock && !_ctx.landingBlock.hidePrice)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                                (_unref(hasDiscount))
                                    ? (_openBlock(), _createBlock(_component_e_icon, {
                                        key: 0,
                                        class: "text-primary w-5 h-5 mr-2",
                                        icon: "discount"
                                    }))
                                    : _createCommentVNode("", true),
                                _createElementVNode("span", null, [
                                    _createTextVNode(_toDisplayString(_unref(t)('course.price')), 1),
                                    (_unref(hasDiscount))
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_unref(t)('course.withDiscount')), 1))
                                        : _createCommentVNode("", true),
                                    _createTextVNode(": ")
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_12, [
                                ((!_unref(plansPayment) && _unref(courseLanding).priceOld > 0) || (_unref(plansPayment) && _unref(minimalPlansPriceOld)))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                                        (_unref(plansPayment) && _unref(plans).length > 1)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_unref(t)('course.from')), 1))
                                            : _createCommentVNode("", true),
                                        _createTextVNode(" " + _toDisplayString(_unref(plansPayment) ? _unref(minimalPlansPriceOld) : _unref(courseLanding).priceOld) + " " + _toDisplayString((_a = _unref(landingCurrency)) === null || _a === void 0 ? void 0 : _a.symbol), 1)
                                    ]))
                                    : _createCommentVNode("", true),
                                ((!_unref(plansPayment) && _unref(courseLanding).price > 0) || (_unref(plansPayment) && _unref(minimalPlansPrice)))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                                        (_unref(plansPayment) && _unref(plans).length > 1)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_unref(t)('course.from')), 1))
                                            : _createCommentVNode("", true),
                                        _createTextVNode(" " + _toDisplayString(_unref(plansPayment) ? _unref(minimalPlansPrice) : _unref(courseLanding).price) + " " + _toDisplayString((_b = _unref(landingCurrency)) === null || _b === void 0 ? void 0 : _b.symbol), 1)
                                    ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_unref(plansPayment) ? _unref(t)('course.freePlan') : _unref(t)('course.completelyFree')), 1))
                            ]),
                            _createElementVNode("div", _hoisted_18, [
                                (studentLimits.value.hasLimitCourse && studentLimits.value.leftLimitStudentsCourse < 1)
                                    ? (_openBlock(), _createBlock(_component_e_button, {
                                        key: 0,
                                        class: "mt-4 w-64 max-w-full",
                                        size: "large",
                                        type: "white",
                                        disabled: ""
                                    }, {
                                        default: _withCtx(function () { return [
                                            _createTextVNode(_toDisplayString(_unref(t)('course.placesEnded')), 1)
                                        ]; }),
                                        _: 1
                                    }))
                                    : (_unref(isIOSApp)() && _unref(isIOSModeratorSchool)())
                                        ? (_openBlock(), _createBlock(_component_e_button, {
                                            key: 1,
                                            class: "mt-4 w-64 max-w-full",
                                            size: "large",
                                            onClick: fakePayment
                                        }, {
                                            default: _withCtx(function () { return [
                                                _createTextVNode(_toDisplayString(_unref(t)('course.enrollNow')), 1)
                                            ]; }),
                                            _: 1
                                        }))
                                        : (_openBlock(), _createBlock(_component_e_button, {
                                            key: 2,
                                            class: "mt-4 w-64 max-w-full",
                                            size: "large",
                                            onClick: _unref(orderAction)
                                        }, {
                                            default: _withCtx(function () { return [
                                                _createTextVNode(_toDisplayString(_unref(t)('course.enrollNow')), 1)
                                            ]; }),
                                            _: 1
                                        }, 8, ["onClick"])),
                                (studentLimits.value.hasLimitCourse)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                        (studentLimits.value.leftLimitStudentsCourse < 1)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_unref(t)('course.groupFull')), 1))
                                            : (studentLimits.value.lastChangeCourse)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(_unref(t)('course.placeLeft', studentLimits.value.leftLimitStudentsCourse)), 1))
                                                : (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(_unref(t)('course.place', studentLimits.value.leftLimitStudentsCourse)), 1))
                                    ]))
                                    : _createCommentVNode("", true)
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ])
            ], 4));
        };
    }
});
